'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _fp = require('lodash/fp');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _capeLodash = require('cape-lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/* globals window */

function scrollToTop() {
  if (typeof window !== 'undefined' && window.scrollTo) window.scrollTo(0, 0);
}

function addScrollTop(_ref) {
  var onClick = _ref.onClick,
      top = _ref.top;

  if (!top) return onClick;
  if (!onClick) return scrollToTop;
  return (0, _fp.over)([scrollToTop, onClick]);
}
var getValidProps = (0, _fp.flow)((0, _capeLodash.setField)('onClick', addScrollTop), (0, _fp.pick)(['href', 'onClick', 'style', 'title']));

function getClassNames(_ref2) {
  var isActive = _ref2.isActive,
      className = _ref2.className,
      isInternal = _ref2.isInternal;

  return (0, _classnames2.default)({ active: isActive, internal: isInternal }, className);
}
// Really simple Link component to help transition from react-router.
function Link(_ref3) {
  var children = _ref3.children,
      props = _objectWithoutProperties(_ref3, ['children']);

  return _react2.default.createElement(
    'a',
    _extends({ className: getClassNames(props) }, getValidProps(props)),
    children
  );
}

Link.propTypes = {
  isActive: _propTypes2.default.bool,
  children: _propTypes2.default.node.isRequired,
  className: _propTypes2.default.string,
  top: _propTypes2.default.bool
};
Link.defaultProps = {
  isActive: false,
  className: null
};
exports.default = Link;


//////////////////
// WEBPACK FOOTER
// ./~/redux-history-component/lib/Link.js
// module id = 1270
// module chunks = 0